"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step3;
    try {
      var _loop = function _loop() {
        var key = _step3.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  FloatingArrow: function FloatingArrow() {
    return import_react2.FloatingArrow;
  },
  FloatingDelayGroup: function FloatingDelayGroup() {
    return import_react2.FloatingDelayGroup;
  },
  FloatingFocusManager: function FloatingFocusManager() {
    return import_react2.FloatingFocusManager;
  },
  FloatingNode: function FloatingNode() {
    return import_react2.FloatingNode;
  },
  FloatingOverlay: function FloatingOverlay() {
    return import_react2.FloatingOverlay;
  },
  FloatingPortal: function FloatingPortal() {
    return import_react2.FloatingPortal;
  },
  FloatingTree: function FloatingTree() {
    return import_react2.FloatingTree;
  },
  arrow: function arrow() {
    return import_react2.arrow;
  },
  autoPlacement: function autoPlacement() {
    return import_react2.autoPlacement;
  },
  autoUpdate: function autoUpdate() {
    return import_react2.autoUpdate;
  },
  computePosition: function computePosition() {
    return import_react2.computePosition;
  },
  createVirtualElement: function createVirtualElement() {
    return _createVirtualElement;
  },
  createVirtualRef: function createVirtualRef() {
    return _createVirtualRef;
  },
  detectOverflow: function detectOverflow() {
    return import_react2.detectOverflow;
  },
  flip: function flip() {
    return import_react2.flip;
  },
  getBoundingClientRect: function getBoundingClientRect() {
    return _getBoundingClientRect;
  },
  getDefaultBoundingClientRect: function getDefaultBoundingClientRect() {
    return _getDefaultBoundingClientRect;
  },
  getOverflowAncestors: function getOverflowAncestors() {
    return import_react2.getOverflowAncestors;
  },
  getRangeBoundingClientRect: function getRangeBoundingClientRect() {
    return _getRangeBoundingClientRect;
  },
  getSelectionBoundingClientRect: function getSelectionBoundingClientRect() {
    return _getSelectionBoundingClientRect;
  },
  hide: function hide() {
    return import_react2.hide;
  },
  inline: function inline() {
    return import_react2.inline;
  },
  limitShift: function limitShift() {
    return import_react2.limitShift;
  },
  makeClientRect: function makeClientRect() {
    return _makeClientRect;
  },
  mergeClientRects: function mergeClientRects() {
    return _mergeClientRects;
  },
  offset: function offset() {
    return import_react2.offset;
  },
  safePolygon: function safePolygon() {
    return import_react2.safePolygon;
  },
  shift: function shift() {
    return import_react2.shift;
  },
  size: function size() {
    return import_react2.size;
  },
  useClick: function useClick() {
    return import_react2.useClick;
  },
  useDelayGroup: function useDelayGroup() {
    return import_react2.useDelayGroup;
  },
  useDelayGroupContext: function useDelayGroupContext() {
    return import_react2.useDelayGroupContext;
  },
  useDismiss: function useDismiss() {
    return import_react2.useDismiss;
  },
  useFloating: function useFloating() {
    return import_react2.useFloating;
  },
  useFloatingNodeId: function useFloatingNodeId() {
    return import_react2.useFloatingNodeId;
  },
  useFloatingParentNodeId: function useFloatingParentNodeId() {
    return import_react2.useFloatingParentNodeId;
  },
  useFloatingPortalNode: function useFloatingPortalNode() {
    return import_react2.useFloatingPortalNode;
  },
  useFloatingToolbar: function useFloatingToolbar() {
    return _useFloatingToolbar;
  },
  useFloatingToolbarState: function useFloatingToolbarState() {
    return _useFloatingToolbarState;
  },
  useFloatingTree: function useFloatingTree() {
    return import_react2.useFloatingTree;
  },
  useFocus: function useFocus() {
    return import_react2.useFocus;
  },
  useHover: function useHover() {
    return import_react2.useHover;
  },
  useId: function useId() {
    return import_react2.useId;
  },
  useInteractions: function useInteractions() {
    return import_react2.useInteractions;
  },
  useListNavigation: function useListNavigation() {
    return import_react2.useListNavigation;
  },
  useRole: function useRole() {
    return import_react2.useRole;
  },
  useTypeahead: function useTypeahead() {
    return import_react2.useTypeahead;
  },
  useVirtualFloating: function useVirtualFloating() {
    return _useVirtualFloating;
  }
});
module.exports = __toCommonJS(src_exports);

// src/createVirtualElement.ts
var _getDefaultBoundingClientRect = function _getDefaultBoundingClientRect() {
  return {
    bottom: 9999,
    height: 0,
    left: -9999,
    right: 9999,
    top: -9999,
    width: 0,
    x: 0,
    y: 0
  };
};
var _createVirtualElement = function _createVirtualElement() {
  return {
    getBoundingClientRect: _getDefaultBoundingClientRect
  };
};

// src/hooks/useFloatingToolbar.ts
var import_react = __toESM(require("react"));
var import_plate_common = require("@udecode/plate-common");
var import_server = require("@udecode/plate-common/server");
var import_slate_react = require("slate-react");
var _useFloatingToolbarState = function _useFloatingToolbarState(_ref) {
  var editorId = _ref.editorId,
    floatingOptions = _ref.floatingOptions,
    focusedEditorId = _ref.focusedEditorId,
    hideToolbar = _ref.hideToolbar,
    ignoreReadOnly = _ref.ignoreReadOnly;
  var selectionExpanded = (0, import_plate_common.useEditorSelector)(import_server.isSelectionExpanded, []);
  var selectionText = (0, import_plate_common.useEditorSelector)(import_server.getSelectionText, []);
  var focused = (0, import_slate_react.useFocused)();
  var _import_react$default = import_react.default.useState(false),
    _import_react$default2 = _slicedToArray(_import_react$default, 2),
    open = _import_react$default2[0],
    setOpen = _import_react$default2[1];
  var _import_react$default3 = import_react.default.useState(false),
    _import_react$default4 = _slicedToArray(_import_react$default3, 2),
    waitForCollapsedSelection = _import_react$default4[0],
    setWaitForCollapsedSelection = _import_react$default4[1];
  var _import_react$default5 = import_react.default.useState(false),
    _import_react$default6 = _slicedToArray(_import_react$default5, 2),
    mousedown = _import_react$default6[0],
    setMousedown = _import_react$default6[1];
  var floating = _useVirtualFloating((0, import_server.mergeProps)({
    getBoundingClientRect: _getSelectionBoundingClientRect,
    onOpenChange: setOpen,
    open: open
  }, floatingOptions));
  return {
    editorId: editorId,
    floating: floating,
    focused: focused,
    focusedEditorId: focusedEditorId,
    hideToolbar: hideToolbar,
    ignoreReadOnly: ignoreReadOnly,
    mousedown: mousedown,
    open: open,
    selectionExpanded: selectionExpanded,
    selectionText: selectionText,
    setMousedown: setMousedown,
    setOpen: setOpen,
    setWaitForCollapsedSelection: setWaitForCollapsedSelection,
    waitForCollapsedSelection: waitForCollapsedSelection
  };
};
var _useFloatingToolbar = function _useFloatingToolbar(_ref2) {
  var editorId = _ref2.editorId,
    floating = _ref2.floating,
    focusedEditorId = _ref2.focusedEditorId,
    hideToolbar = _ref2.hideToolbar,
    ignoreReadOnly = _ref2.ignoreReadOnly,
    mousedown = _ref2.mousedown,
    open = _ref2.open,
    selectionExpanded = _ref2.selectionExpanded,
    selectionText = _ref2.selectionText,
    setMousedown = _ref2.setMousedown,
    setOpen = _ref2.setOpen,
    setWaitForCollapsedSelection = _ref2.setWaitForCollapsedSelection,
    waitForCollapsedSelection = _ref2.waitForCollapsedSelection;
  var _a;
  import_react.default.useEffect(function () {
    if (!(editorId === focusedEditorId) || ignoreReadOnly) {
      setWaitForCollapsedSelection(true);
    }
    if (!selectionExpanded) {
      setWaitForCollapsedSelection(false);
    }
  }, [editorId, focusedEditorId, ignoreReadOnly, selectionExpanded, setWaitForCollapsedSelection]);
  import_react.default.useEffect(function () {
    var mouseup = function mouseup() {
      return setMousedown(false);
    };
    var mousedown2 = function mousedown2() {
      return setMousedown(true);
    };
    document.addEventListener("mouseup", mouseup);
    document.addEventListener("mousedown", mousedown2);
    return function () {
      document.removeEventListener("mouseup", mouseup);
      document.removeEventListener("mousedown", mousedown2);
    };
  }, []);
  import_react.default.useEffect(function () {
    if (!selectionExpanded || !selectionText || mousedown && !open || hideToolbar) {
      setOpen(false);
    } else if (selectionText && selectionExpanded && !waitForCollapsedSelection) {
      setOpen(true);
    }
  }, [setOpen, editorId, focusedEditorId, hideToolbar, ignoreReadOnly, selectionExpanded, selectionText, mousedown, waitForCollapsedSelection, open]);
  var update = floating.update;
  var selectionTextLength = (_a = selectionText == null ? void 0 : selectionText.length) != null ? _a : 0;
  import_react.default.useEffect(function () {
    if (selectionTextLength > 0) {
      update == null ? void 0 : update();
    }
  }, [selectionTextLength, update]);
  return {
    hidden: !open,
    props: {
      style: floating.style
    },
    ref: floating.refs.setFloating
  };
};

// src/hooks/useVirtualFloating.ts
var import_react3 = __toESM(require("react"));
var import_plate_common4 = require("@udecode/plate-common");

// src/libs/floating-ui.ts
var import_react2 = require("@floating-ui/react");

// src/utils/getBoundingClientRect.ts
var import_plate_common2 = require("@udecode/plate-common");
var import_server2 = require("@udecode/plate-common/server");
var import_slate = require("slate");

// src/utils/makeClientRect.ts
var _makeClientRect = function _makeClientRect(_ref3) {
  var bottom = _ref3.bottom,
    left = _ref3.left,
    right = _ref3.right,
    top = _ref3.top;
  var width = right - left;
  var height = bottom - top;
  var props = {
    bottom: bottom,
    height: height,
    left: left,
    right: right,
    top: top,
    width: width,
    x: left,
    y: top
  };
  return __spreadProps(__spreadValues({}, props), {
    toJSON: function toJSON() {
      return props;
    }
  });
};

// src/utils/mergeClientRects.ts
var _mergeClientRects = function _mergeClientRects(clientRects) {
  if (clientRects.length === 0) {
    throw new Error("clientRects should not be empty");
  }
  return _makeClientRect({
    bottom: Math.max.apply(Math, _toConsumableArray(clientRects.map(function (rect) {
      return rect.bottom;
    }))),
    left: Math.min.apply(Math, _toConsumableArray(clientRects.map(function (rect) {
      return rect.left;
    }))),
    right: Math.max.apply(Math, _toConsumableArray(clientRects.map(function (rect) {
      return rect.right;
    }))),
    top: Math.min.apply(Math, _toConsumableArray(clientRects.map(function (rect) {
      return rect.top;
    })))
  });
};

// src/utils/getBoundingClientRect.ts
var _getBoundingClientRect = function _getBoundingClientRect(editor, at) {
  var atRanges = function () {
    if (!at) return [editor.selection].filter(Boolean);
    var atArray = Array.isArray(at) && !import_slate.Path.isPath(at) ? at : [at];
    return atArray.map(function (location) {
      return (0, import_server2.getRange)(editor, location);
    });
  }();
  var clientRects = atRanges.map(function (range) {
    var _a;
    return (_a = (0, import_plate_common2.toDOMRange)(editor, range)) == null ? void 0 : _a.getBoundingClientRect();
  }).filter(Boolean);
  if (clientRects.length === 0) return void 0;
  return _mergeClientRects(clientRects);
};

// src/utils/createVirtualRef.ts
var _createVirtualRef = function _createVirtualRef(editor, at) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    fallbackRect = _ref4.fallbackRect;
  return {
    current: {
      getBoundingClientRect: function getBoundingClientRect() {
        var rect = _getBoundingClientRect(editor, at) || fallbackRect;
        if (!rect) {
          throw new Error("Could not get the bounding client rect of the location. Please provide a fallbackRect.");
        }
        return rect;
      }
    }
  };
};

// src/utils/getRangeBoundingClientRect.ts
var import_plate_common3 = require("@udecode/plate-common");
var _getRangeBoundingClientRect = function _getRangeBoundingClientRect(editor, at) {
  if (!at) return _getDefaultBoundingClientRect();
  var domRange = (0, import_plate_common3.toDOMRange)(editor, at);
  if (!domRange) return _getDefaultBoundingClientRect();
  return domRange.getBoundingClientRect();
};

// src/utils/getSelectionBoundingClientRect.ts
var _getSelectionBoundingClientRect = function _getSelectionBoundingClientRect() {
  var domSelection = window.getSelection();
  if (!domSelection || domSelection.rangeCount < 1) {
    return _getDefaultBoundingClientRect();
  }
  var domRange = domSelection.getRangeAt(0);
  return domRange.getBoundingClientRect();
};

// src/hooks/useVirtualFloating.ts
var _useVirtualFloating = function _useVirtualFloating(_a) {
  var _b = _a,
    _b$getBoundingClientR = _b.getBoundingClientRect,
    getBoundingClientRect2 = _b$getBoundingClientR === void 0 ? _getSelectionBoundingClientRect : _b$getBoundingClientR,
    floatingOptions = __objRest(_b, ["getBoundingClientRect"]);
  var virtualElementRef = import_react3.default.useRef(_createVirtualElement());
  var _import_react3$defaul = import_react3.default.useState(true),
    _import_react3$defaul2 = _slicedToArray(_import_react3$defaul, 2),
    visible = _import_react3$defaul2[0],
    setVisible = _import_react3$defaul2[1];
  var floatingResult = (0, import_react2.useFloating)(__spreadValues({
    // update on scroll and resize
    whileElementsMounted: import_react2.autoUpdate
  }, floatingOptions));
  var middlewareData = floatingResult.middlewareData,
    refs = floatingResult.refs,
    strategy = floatingResult.strategy,
    update = floatingResult.update,
    x = floatingResult.x,
    y = floatingResult.y;
  (0, import_plate_common4.useIsomorphicLayoutEffect)(function () {
    virtualElementRef.current.getBoundingClientRect = getBoundingClientRect2;
  }, [getBoundingClientRect2, update]);
  (0, import_plate_common4.useIsomorphicLayoutEffect)(function () {
    refs.setReference(virtualElementRef.current);
  }, [refs]);
  (0, import_plate_common4.useIsomorphicLayoutEffect)(function () {
    if (!(middlewareData == null ? void 0 : middlewareData.hide)) return;
    var referenceHidden = middlewareData.hide.referenceHidden;
    setVisible(!referenceHidden);
  }, [middlewareData.hide]);
  return __spreadProps(__spreadValues({}, floatingResult), {
    style: {
      display: floatingOptions.open === false ? "none" : void 0,
      left: x != null ? x : 0,
      position: strategy,
      top: y != null ? y : 0,
      visibility: visible ? void 0 : "hidden"
    },
    virtualElementRef: virtualElementRef
  });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  FloatingArrow: FloatingArrow,
  FloatingDelayGroup: FloatingDelayGroup,
  FloatingFocusManager: FloatingFocusManager,
  FloatingNode: FloatingNode,
  FloatingOverlay: FloatingOverlay,
  FloatingPortal: FloatingPortal,
  FloatingTree: FloatingTree,
  arrow: arrow,
  autoPlacement: autoPlacement,
  autoUpdate: autoUpdate,
  computePosition: computePosition,
  createVirtualElement: _createVirtualElement,
  createVirtualRef: _createVirtualRef,
  detectOverflow: detectOverflow,
  flip: flip,
  getBoundingClientRect: _getBoundingClientRect,
  getDefaultBoundingClientRect: _getDefaultBoundingClientRect,
  getOverflowAncestors: getOverflowAncestors,
  getRangeBoundingClientRect: _getRangeBoundingClientRect,
  getSelectionBoundingClientRect: _getSelectionBoundingClientRect,
  hide: hide,
  inline: inline,
  limitShift: limitShift,
  makeClientRect: _makeClientRect,
  mergeClientRects: _mergeClientRects,
  offset: offset,
  safePolygon: safePolygon,
  shift: shift,
  size: size,
  useClick: useClick,
  useDelayGroup: useDelayGroup,
  useDelayGroupContext: useDelayGroupContext,
  useDismiss: useDismiss,
  useFloating: useFloating,
  useFloatingNodeId: useFloatingNodeId,
  useFloatingParentNodeId: useFloatingParentNodeId,
  useFloatingPortalNode: useFloatingPortalNode,
  useFloatingToolbar: _useFloatingToolbar,
  useFloatingToolbarState: _useFloatingToolbarState,
  useFloatingTree: useFloatingTree,
  useFocus: useFocus,
  useHover: useHover,
  useId: useId,
  useInteractions: useInteractions,
  useListNavigation: useListNavigation,
  useRole: useRole,
  useTypeahead: useTypeahead,
  useVirtualFloating: _useVirtualFloating
});